import * as _ from "lodash";
import {IComponentOptions} from "angular";
import {UploadFile} from "../../model/UploadFile";

class FileUploadController {
    private isUploading: boolean;
    private queue: UploadFile[];
    private maxSizeMb: number;
    private maxSize: number;
    private label: string;
    private labelClass: string;
    private accept: string;
    private ngModel: any;
    private onUploadComplete: any;
    private onUploadRemoved: any;
    private clearQueueOnComplete: boolean;
    private endpoint: string;
    private onUploadError: any;
    private maxNumberOfFiles: number;
    private existingAttachments: any[];

    /* @ngInject */
    constructor(private $log: ng.ILogService,
                private $http: ng.IHttpService,
                private $q,
                private Upload) {

        if (this.ngModel === undefined) {
            this.ngModel = [];
        }

        $log.debug("fileUplodController#");
        this.queue = new Array<UploadFile>();

        this.label = this.label ? this.label : "Attachments";
        this.queue = this.queue ? this.queue : [];

    }

    public $onInit() {
        if (!this.maxSizeMb) {
            //Allow 1gb file if max size not specified
            this.maxSize = 1000 * 1024 * 1024;
            this.maxSizeMb = 1000;
        } else {
            this.maxSize = this.maxSizeMb * 1024 * 1024;
        }

        if (!this.accept) {
            this.accept = "*";
        }

        this.maxNumberOfFiles = this.maxNumberOfFiles ?  parseInt(this.maxNumberOfFiles as any, 10) : 20;
    }


    public remove(item, upload): any {
        return () => {
            if (item.isUploading) {
                upload.abort();
            }
            _.remove(this.queue, (current) => {
                return current === item;
            });
            this.updateModel();

            if (this.onUploadRemoved) {
                this.onUploadRemoved({file: item.file});
            }

        };
    }

    public updateModel() {
        this.ngModel.length = 0;
        _.each(this.queue, (item) => {
            if (item.isSuccess && item.response) {
                this.$log.info("updateModel", item);
                const attachment: any = this.constructAttachmentHash(item);

                this.ngModel.push(attachment);
                if (this.clearQueueOnComplete) {
                    this.queue = _.without(this.queue, item);
                }
            }
        });

        if (!this.endpoint) {
            // No endpoint defined so continue with default behavior
            if (this.onUploadComplete && this.ngModel.length > 0) {
                this.onUploadComplete({attachments: this.ngModel});
            }
        }

    }

    public constructAttachmentHash(item) {
        if (!item) {
            return null;
        }

        const attachment: any = {
            filename: item.file ? item.file.name : "",
            gcsObjectName: item.response ? item.response.mediaUrl : "",
            mediaLink: item.response ? item.response.mediaUrl : "",
            gcsObjectId: item.response ? item.response.name : "",
            bucket: item.response ? item.response.bucket : "",
            contentType: item.response ? item.file.type : "",
            id: item.response ? item.response.id : "",
            attachmentUploadId: item.response ? item.response.attachmentUploadId : "",
            size: item.response ? item.file.size : ""
        };

        return attachment;
    }

    public uploadFiles(files: any, errFiles) {

        if (files !== undefined && files.length > 0) {
            this.isUploading = true;

            const itemPromises: any = _.map(files, (file: any) => {

                const item: UploadFile = new UploadFile();
                item.file = file;
                item.progress = 0;
                this.queue.push(item);

                if (file.size > this.maxSize) {
                    item.isUploading = false;
                    item.isError = true;
                    item.errorMessage = "File size exceeds limit";
                    item.remove = this.remove(item, null);
                    this.$log.debug("item set to error %o", item);
                    return this.$q.when(item);
                }
                this.$log.info("type is " + file.type);
                if (this.endpoint) {
                    item.isUploading = true;

                    const upload: any = this.Upload.upload({
                        url: this.endpoint,
                        data: {
                            file: file
                        },
                        headers: {
                            "Content-Type": file.type
                        }
                    });

                    const promise: any = upload.then((response) => {
                        item.response = response.data;
                        item.isUploading = false;
                        item.isSuccess = true;
                        item.progress = 100.0;
                        if (this.onUploadComplete) {
                            this.onUploadComplete();
                        }
                        return item;
                    }, (response) => {
                        item.isUploading = false;
                        item.isError = true;
                        if (this.onUploadError) {
                            this.onUploadError();
                        }
                        return item;
                    }, (evt) => {
                        let progress = Math.round((evt.loaded / evt.total) * 100);
                        if (progress > 100) {
                            progress = 100;
                        }
                        item.progress = progress;
                    });

                    return promise;
                } else {
                    return this.$http.post("/attachment/uploadUrl", {name: file.name, type: file.type, size: file.size})
                        .then((resp: any) => {

                                item.isUploading = true;
                                const uploadUrl: any = resp.data.url;

                                const upload: any = this.Upload.upload({
                                    url: uploadUrl,
                                    resumeChunkSize: "1MB",
                                    data: {
                                        file: file
                                    }
                                });

                                item.remove = this.remove(item, upload);

                                const promise: any = upload.then((response) => {
                                    item.response = response.data;
                                    item.isUploading = false;
                                    item.isSuccess = true;
                                    item.progress = 100.0;
                                    return item;
                                }, (response) => {
                                    item.isUploading = false;
                                    item.isError = true;
                                    return item;
                                }, (evt) => {
                                    let progress = Math.round((evt.loaded / evt.total) * 100);
                                    if (progress > 100) {
                                        progress = 100;
                                    }
                                    item.progress = progress;
                                });

                                return promise;

                            }, (resp) => {
                                item.isError = true;
                            }
                        );
                }

            });

            this.$q.all(itemPromises).then(() => {
                this.isUploading = false;
                this.updateModel();
            });
        }
    }

}

export const FileUploadComponent: IComponentOptions = {
    bindings: {
        ngModel: "=?",
        isUploading: "=",
        endpoint: "=",
        showError: "=",
        showErrorExp: "&",
        isSingleFileUpload: "=",
        accept: "@",
        copy: "@",
        label: "@",
        labelClass: "@",
        maxSizeMb: "@",
        onUploadComplete: "&",
        onUploadError: "&",
        onUploadRemoved: "&",
        queue: "<?",
        clearQueueOnComplete: "=",
        maxNumberOfFiles: "@",
        existingAttachments: "<?"
    },
    controller: FileUploadController,
    controllerAs: "vm",
    template: require("./file-upload.html")
};



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/main/client/app/shared/widget/file-upload/file-upload.component.ts